module.exports = __webpack_public_path__ + "static/logo-light-23f57275bf7ed1d92b42d10de69dd391.png";